import { render, staticRenderFns } from "./CustomFormProfileForm.vue?vue&type=template&id=241eb025&scoped=true"
import script from "./CustomFormProfileForm.vue?vue&type=script&lang=js"
export * from "./CustomFormProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241eb025",
  null
  
)

export default component.exports